import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { spacing } from '../../theme/designSystem';

/**
 * EmptyState Component
 *
 * Displays a consistent empty state message with optional action button.
 * Styled to match the Blackbird minimal aesthetic.
 *
 * @param {string} message - The message to display
 * @param {ReactNode} action - Optional action button or element
 */
function EmptyState({ message, action }) {
  return (
    <Box
      textAlign="center"
      py={spacing.section}
      bg="background.shade2"
      border="1px dashed"
      borderColor="border.strong"
      borderRadius="md"
    >
      <VStack spacing={spacing.item}>
        <Text color="theme.mediumGray" fontSize="md">
          {message}
        </Text>
        {action}
      </VStack>
    </Box>
  );
}

export default EmptyState;
